export const ASSET_TYPE_OPTIONS = [
  { value: 'E', label: 'Equities' },
  { value: 'O', label: 'Options' },
];

export const SECURITY_TYPE_OPTIONS = [
  '',
  'AA',
  'AB',
  'AC',
  'AP',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'E',
  'EAC',
  'FA',
  'FC',
  'FP',
  'FR',
  'FS',
  'FT',
  'FU',
  'FW',
  'G',
  'GB',
  'GC',
  'GP',
];

export const SEC_SUB_TYPE_OPTIONS = [
  '',
  '2',
  '3',
  '5',
  'B',
  'C',
  'J',
  'K',
  'M',
  'N',
  'P',
  'V',
  'W',
  'Y',
];

export const ASSET_CATEGORY_OPTIONS = [
  '',
  'A',
  'E',
  'F',
  'G',
  'GF',
  'H',
  'P',
  'S',
  'STOCK_ASSET_CATEGORY_EQUITY',
  'STOCK_ASSET_CATEGORY_PREFERRED',
  'STOCK_ASSET_CATEGORY_WARRANT',
  'STOCK_ASSET_CATEGORY_RIGHT',
  'STOCK_ASSET_CATEGORY_MUTUALFUND',
  'STOCK_ASSET_CATEGORY_ETF',
  'STOCK_ASSET_CATEGORY_COMPOSITE',
];

export const LEVERAGE_FACTOR_OPTIONS = ['0', '1'];

export const EQUITY_MULTIPLIER_OPTIONS = ['0', '1'];

export function getAssetTypeDefaults(assetType) {
  if (assetType === 'O') {
    return {
      leverageFactor: '0',
      multiplier: '100',
      size: '0',
      exchangeCountry: '',
    };
  }
  return {
    leverageFactor: '1',
    multiplier: '1',
    size: '',
    exchangeCountry: 'US',
  };
}
